<template>
  <div class="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
    <a
      v-for="shop in shops"
      :key="shop.slug"
      :href="shop.url"
      class="group flex gap-4 rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-primary-200 hover:shadow-sm"
    >
      <div class="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-100 ring-1 ring-slate-200">
        <img
          v-if="shop.logo"
          :src="logoSrc(shop.logo)"
          :alt="shop.name"
          class="size-full object-contain p-1.5"
        >
        <span v-else class="text-lg font-semibold text-primary-600">
          {{ initial(shop.name) }}
        </span>
      </div>
      <div class="min-w-0">
        <p class="truncate font-semibold text-slate-900 group-hover:text-primary-700">
          {{ shop.name }}
        </p>
        <p class="mt-0.5 truncate text-sm text-primary-600">
          {{ shop.hostLabel }}
        </p>
        <p v-if="shop.tagline" class="mt-1 line-clamp-2 text-sm text-slate-500">
          {{ shop.tagline }}
        </p>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { resolveMediaUrl } from '~/utils/mediaUrl'
import type { PlatformPublicShop } from '~/composables/usePlatformShops'

defineProps<{
  shops: PlatformPublicShop[]
}>()

const config = useRuntimeConfig()

function logoSrc(logo: string) {
  return resolveMediaUrl(logo, String(config.public.apiOrigin || ''))
}

function initial(name: string) {
  return (name.trim().charAt(0) || 'N').toUpperCase()
}
</script>
